import { Box } from "@mui/material"
import Text from "../../../theme/text/Text"

export const HighlightedColumn = (props) => {
    return (
        <Box
            sx={{
                height:32,
                px:2,
                position:"relative",
                display:'flex',
                alignItems:'center',
                borderRadius:4,
                "&:before" : {
                    content:"''",
                    background:props.strat?.color[props.theme.palette.mode],
                    width:1,
                    height:1,
                    opacity:0.1,
                    borderRadius:4,
                    position:"absolute",
                    left:0,
                    top:0,
                }
            }}
        >
            <Text bold color={props.strat?.color[props.theme.palette.mode]}>
                {props.value}
            </Text>
        </Box>
    )
}